export const HOUR_HEIGHT = 48
export const ONE_MINUTE_MS = 60 * 1000
export const MIN_LANE_WIDTH = 70

export const buildOverlapClusters = (events) => {
  const sorted = [...events].sort((a, b) => (a.startMoment?.valueOf() ?? 0) - (b.startMoment?.valueOf() ?? 0))
  const clusters = []
  sorted.forEach((ev) => {
    const start = ev.startMoment?.valueOf() ?? 0
    const end = ev.endMoment?.valueOf() ?? start
    const hit = clusters.filter((c) => c.maxEnd > start + ONE_MINUTE_MS)
    if (hit.length === 0) {
      clusters.push({ events: [ev], maxEnd: end })
    } else {
      const merged = hit.reduce((acc, c) => {
        clusters.splice(clusters.indexOf(c), 1)
        acc.events.push(...c.events)
        acc.maxEnd = Math.max(acc.maxEnd, c.maxEnd)
        return acc
      }, { events: [ev], maxEnd: end })
      merged.maxEnd = Math.max(merged.maxEnd, end)
      clusters.push(merged)
    }
  })
  return clusters.map((c) => c.events)
}

export const assignColumnsInCluster = (clusterEvents) => {
  const sorted = [...clusterEvents].sort((a, b) => (a.startMoment?.valueOf() ?? 0) - (b.startMoment?.valueOf() ?? 0))
  const colEnds = []
  const assignments = []
  sorted.forEach((ev) => {
    const startVal = ev.startMoment?.valueOf() ?? 0
    const endVal = ev.endMoment?.valueOf() ?? startVal
    let colIndex = colEnds.findIndex((colEnd) => colEnd + ONE_MINUTE_MS <= startVal)
    if (colIndex === -1) { colIndex = colEnds.length; colEnds.push(endVal) }
    else colEnds[colIndex] = endVal
    assignments.push({ ev, colIndex })
  })
  const totalCols = Math.max(colEnds.length, 1)
  return assignments.map(({ ev, colIndex }) => ({ ...ev, colIndex, totalCols }))
}

export const computeEventColumns = (events) => buildOverlapClusters(events).flatMap(assignColumnsInCluster)

export const getEventPosition = (ev, startHour) => {
  const { startMoment, endMoment } = ev
  if (!startMoment?.isValid() || !endMoment?.isValid()) return null
  const startMins = (startMoment.hour() - startHour) * 60 + startMoment.minute()
  const endMins = (endMoment.hour() - startHour) * 60 + endMoment.minute()
  const duration = Math.max(endMins - startMins, 30)
  return { top: Math.max(0, startMins) * (HOUR_HEIGHT / 60), height: duration * (HOUR_HEIGHT / 60) }
}

export const getLanesForDay = (eventsWithCols) =>
  eventsWithCols.length > 0 ? Math.max(...eventsWithCols.map((e) => e.totalCols)) : 1

export const getDayMinWidth = (lanes) => Math.max(120, lanes * MIN_LANE_WIDTH)
